import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material'
// eslint-disable-next-line no-restricted-imports -- Use sx props or styled components to create CSS
import { CheckCircle } from '@dhl/icons'
import { BasePage } from '~/pages'
import { useQueryParam, useTranslationContext } from '~/hooks'
import type { BusinessUnitCode } from '~/model'

export const PickupSuccessPage = () => {
  const { confirmationNumber } = useParams<{ confirmationNumber: string | undefined }>()
  const { t } = useTranslation()
  const businessUnit: BusinessUnitCode = useQueryParam('businessUnit') as BusinessUnitCode
  const translationContext = useTranslationContext(businessUnit)

  return (
    <BasePage testId="pickup-success-page" isLoading={false}>
      <Box mt={4}>
        <Card>
          <CardHeader title={t('title')} />
          <Divider />
          <CardContent>
            <Grid container direction="row" alignItems="center" size={{ xs: 12 }}>
              <Grid>
                <CheckCircle
                  sx={({ palette: { success } }) => ({
                    marginRight: 2,
                    fontSize: 24,
                    color: success.main,
                  })}
                />
              </Grid>
              <Grid>
                <Typography data-test="success-title">
                  {t('success.pickup.title', { ...translationContext, confirmationNumber: confirmationNumber ?? `` })}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </BasePage>
  )
}
